module.exports = __webpack_public_path__ + "onlinepurchase-icon.d7aa2a86514511ca176a.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/onlinepurchase-icon.svg
// module id = ../../../../../src/img/icon/onlinepurchase-icon.svg
// module chunks = styles